import { useEffect, useRef } from "react"

import { App, Col, Divider, Flex, Radio, Row, Space, Typography } from "antd"
import cls from "classname"
import dayjs from "dayjs"
import i18n from "i18next"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { connect, useSelector } from "react-redux"

import Select from "../../Components/Select"
import TitleSection from "../../Components/TitleSection/TitleSection"
import { useExternalDemoMode } from "../../hooks/useExternalDemoMode"
import NavCreators from "../../Redux/NavRedux"
import SettingCreators from "../Setting/reducer"
import UserCreators from "../User/reducer"

const { Text } = Typography

const Appearance = ({
  fetching,
  userInfo,

  theme,

  settingFetching,
  languages,
  changeLang,
  userSaveResultReset,
  getLanguagesList,
  ...props
}) => {
  const { language } = userInfo
  const isMobile = useSelector((state) => state.nav.isMobile)
  const { t } = useTranslation()
  const { notification } = App.useApp()
  const externalDemoMode = useExternalDemoMode()

  const data = useRef({ language })

  const notificationConfig = {
    closeIcon: <Text>{t("Dismiss")}</Text>,
    style: { minWidth: "420px" }
  }

  const currentTheme = theme
  /*const handleChangeTheme = (newTheme) => {
    props.changeTheme(newTheme)
  }*/

  const onChangeTheme = (e) => {
    props.changeTheme(e.target.value)
  }

  useEffect(() => {
    if (!languages.length) getLanguagesList()
  }, [])

  useEffect(() => {
    if (language !== data.current.language) {
      i18n.changeLanguage(language)
      dayjs.locale(language === "zh-hans" ? "zh-cn" : language)
      notification.success({
        message: t("Language has been changed"),
        ...notificationConfig
      })
      userSaveResultReset()
    }
    /*eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [language])

  function handleChangeLang(lang) {
    console.log("lang", lang)
    changeLang(lang)
    data.current = { ...data.current, language: "" }
  }

  const optionsLanguages = languages
    ? languages.map((el) => ({
        label: el.name,
        value: el.value
      }))
    : []

  return (
    <div>
      <TitleSection
        icon="color_palette"
        title="Appearance"
        description="Fine-tune the appearance."
        style={{ margin: isMobile ? "-16px -16px 16px" : "-32px -32px 24px" }}
      />

      <Row>
        <Col flex={"1 1 300px"}>
          <Space size={8} direction={"vertical"} style={{ paddingBottom: isMobile && 16 }}>
            <Text strong>{t("Interface theme")}</Text>
            <Text type="secondary">{t("Select your theme for Chargeback.")}</Text>
          </Space>
        </Col>
        <Col flex={"0 1 420px"}>
          <Flex gap={24}>
            <Space direction={"vertical"}>
              <div className={cls("theme-card light", { active: currentTheme === "light" })}>
                <Radio
                  value={"light"}
                  checked={currentTheme === "light"}
                  onChange={onChangeTheme}
                />
              </div>
              <Text type="secondary" strong>
                {t("Light")}
              </Text>
            </Space>

            <Space direction={"vertical"}>
              <div className={cls("theme-card dark", { active: currentTheme === "dark" })}>
                <Radio value={"dark"} checked={currentTheme === "dark"} onChange={onChangeTheme} />
              </div>
              <Text type="secondary" strong>
                {t("Dark")}
              </Text>
            </Space>
          </Flex>
        </Col>
      </Row>

      <Divider style={{ visibility: isMobile && "hidden", margin: isMobile && "12px 0" }} />

      <Row>
        <Col flex={"1 1 240px"}>
          <Space size={8} direction={"vertical"} style={{ paddingBottom: isMobile && 16 }}>
            <Text strong>{t("Language")}</Text>
            <Text type="secondary">{t("Select the language of the platform.")}</Text>
          </Space>
        </Col>
        <Col flex={"0 1 420px"} style={{ width: isMobile && "100%" }}>
          <Select
            size="large"
            defaultValue={language}
            onChange={(lang) => {
              handleChangeLang(lang)
            }}
            options={optionsLanguages}
            style={{ width: !isMobile ? 150 : "100%" }}
            dropdownStyle={{ width: 200 }}
            disabled={externalDemoMode}
          />
        </Col>
      </Row>
    </div>
  )
}

Appearance.propTypes = {
  fetching: PropTypes.bool,
  notifications: PropTypes.array
}

const mapStateToProps = (state) => ({
  userInfo: state.auth.userInfo,

  theme: state.nav.theme,

  settingFetching: state.setting.fetching,
  languages: state.setting.languages,

  fetching: state.user.fetching
})

const mapDispatchToProps = (dispatch) => ({
  changeTheme: (theme) => dispatch(NavCreators.navSetProp("theme", theme)),

  getLanguagesList: () => dispatch(SettingCreators.getLanguagesListRequest()),
  changeLang: (lang) => dispatch(UserCreators.changeLanguageRequest(lang)),
  userSaveResultReset: () => dispatch(UserCreators.userSaveResultReset())
})

export default connect(mapStateToProps, mapDispatchToProps)(Appearance)
